import { PageQueriesBaseModel } from './page-queries-base.model';

export type PageQueriesInput<T> = { [P in keyof T]?: T[P] };

export class PageQueriesModel extends PageQueriesBaseModel {
  pageSize = 10;
  page = 0;
  search = '';
  ascending = false;
  sortKey = '';
  order: string;

  constructor(d?: PageQueriesInput<PageQueriesModel>) {
    super();

    if (!d) {
      return;
    }
    Object.assign(this, d);
  }
}
